/* src/components/product/CatalogueGridWrapper.tsx */

"use client";

import { useState } from "react";
import { ProductGrid } from "./ProductGrid";

// 定义从服务器组件接收的 props 类型
type ProductPreview = {
	id: string;
	name: string;
	imageUrl: string;
};

type CatalogueGridWrapperProps = {
	products: ProductPreview[];
};

// 这个组件是客户端组件，负责管理分页状态
export function CatalogueGridWrapper({ products }: CatalogueGridWrapperProps) {
	// 在这里使用 useState 来管理当前页码
	const [currentPage, setCurrentPage] = useState(1);

	// 定义一个函数来处理页码变化
	const handlePageChange = (newPage: number) => {
		setCurrentPage(newPage);
	};

	// 将状态和处理函数传递给 ProductGrid 组件
	return (
		<ProductGrid
			products={products}
			currentPage={currentPage}
			onPageChange={handlePageChange}
		/>
	);
}
